import { put, take, fork, call } from 'redux-saga/effects';

import { ContactServiceAction, ContactServiceScope } from './types';
import { ScopeErrorAction } from '../scope-error/types';

import * as Api from '../../service/api';
import { enableScopeLoading, disableScopeLoading } from '../scope-loading/actions';

function* submitContactServiceFlow() {
  while (true) {
    const request = yield take(ContactServiceAction.SUBMIT_CONTACT_SERVICE);
    yield put(enableScopeLoading(ContactServiceScope));
    try {
      yield call(Api.contactService.submitContactService, request.payload);
    } catch (error) {
      yield put({ type: ScopeErrorAction.SET_SCOPE_ERROR, payload: ContactServiceScope, error });
    } finally {
      yield put(disableScopeLoading(ContactServiceScope));
    }
  }
}

export default function* contactServiceSaga() {
  yield fork(submitContactServiceFlow);
}
